import { BehaviorSubject, Observable } from "rxjs";
import { OFFICE_API_VERSION } from "@core/core-boot/core-boot";
import { awaitOfficeReady } from "@core/core-boot/office-ready";
import { IClientENV, ICoreEnv } from "@core/core-env/core-env.types";
import { environment } from "@env";

export class CoreEnv implements ICoreEnv
{
    private _environment: BehaviorSubject<IClientENV> = new BehaviorSubject<IClientENV>(this.env);

    constructor(private env: IClientENV) {}

    public get(): IClientENV
    {
        return this._environment.getValue();
    }

    public $get(): Observable<IClientENV>
    {
        return this._environment.asObservable();
    }

    get isOffice(): boolean
    {
        const isHasOffice = this._environment.getValue().office;
        return !!isHasOffice && isHasOffice === OFFICE_API_VERSION.v1;
    }

    public async isHostOutlook(): Promise<boolean>
    {
        const info = this.get();
        return info.host === Office.HostType.Outlook;
    }

    static async init(): Promise<CoreEnv>
    {
        const info = await awaitOfficeReady();
        if (!info.platform || !info.host)
        {
            throw new Error('CoreEnv.init called without an Office host');
        }

        const office = environment.office_core_version === OFFICE_API_VERSION.v2
            ? OFFICE_API_VERSION.v2
            : OFFICE_API_VERSION.v1;

        return new CoreEnv({ ...info, office });
    }
}
